// @flow
import { TiposVisitantesActionTypes } from './constants';

type TiposVisitantesAction = { type: string, payload: {} | string };

// common success
export const tiposVisitantesApiResponseSuccess = (actionType: string, data: any): TiposVisitantesAction => ({
    type: TiposVisitantesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const tiposVisitantesApiResponseError = (actionType: string, error: string): TiposVisitantesAction => ({
    type: TiposVisitantesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getTiposVisitante = (id: string): TiposVisitantesAction => ({
    type: TiposVisitantesActionTypes.GET_TIPO,
    payload: { id },
});

export const addTiposVisitante = (tiposVisitante:any):TiposVisitantesAction=>({
    type:TiposVisitantesActionTypes.ADD_TIPO,
    payload:tiposVisitante
})
export const updateTiposVisitante = (tiposVisitante:any):TiposVisitantesAction=>({
    type:TiposVisitantesActionTypes.UPDATE_TIPO,
    payload:tiposVisitante
})
export const deleteTiposVisitante = (id:string):TiposVisitantesAction=>({
    type:TiposVisitantesActionTypes.DELETE_TIPO,
    payload:{id}
})

export const listTiposVisitantes = (params:any): TiposVisitantesAction => ({
    type: TiposVisitantesActionTypes.LIST_TIPOS,
    payload: params,
});

export const setFiltersTiposVisitantes = (params:any): TiposVisitantesAction => ({
    type: TiposVisitantesActionTypes.SET_FILTER,
    payload: params,
})

export const resetTiposVisitantes = (): TiposVisitantesAction => ({
    type: TiposVisitantesActionTypes.RESET,
    payload: {},
});

